import axios from "axios";

// Tạo axios instance
const requestFee = axios.create({
  baseURL: "http://127.0.0.1:3000",
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  },
});
// Add a request interceptor
requestFee.interceptors.request.use(
  function (config) {
    // Add OAuth 1.0a authentication to the request
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
requestFee.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {

    return error.response.data;
  }
);

export default requestFee;
